if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.subtotalArr = document.querySelectorAll('.totals__subtotal-value');
      this.cartDrawer = document.querySelector('cart-drawer');

      //Detect sticky
      const observer = new IntersectionObserver(
        ([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
        { threshold: [1] }
      );

      observer.observe(this);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartDrawer.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.product-form__spinner .icon-spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          return fetch('/?section_id=intus-header', {
            method: 'get',
            'Content-Type': 'application/json'
          });
        })
        .then((data) => data.text())
        .then((dataText) => {

          const updatedCart = new DOMParser()
            .parseFromString(dataText, 'text/html')
            .getElementById('cart-drawer-items').innerHTML;
          document.getElementById('cart-drawer-items').innerHTML = updatedCart;

          const updatedSubtotal = new DOMParser().parseFromString(dataText, 'text/html')
            .querySelector('.totals__subtotal-value').innerHTML;
          if (this.subtotalArr) {
            this.subtotalArr.forEach(function(el) {
              el.innerHTML = updatedSubtotal;
            });
          };

          const updatedCartIcon = new DOMParser()
            .parseFromString(dataText, 'text/html')
            .getElementById('icon-cart').innerHTML;
          document.getElementById('icon-cart').innerHTML = updatedCartIcon;

          this.cartDrawer.open(true);
        
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.product-form__spinner .icon-spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
